import * as actionTypes from '../actions/actionTypes';
import uuid from 'uuid';

export const ExperienceBookingSuccess = (experienceBookingSuccess) => ({
  type: actionTypes.SET_EXPERIENCE_BOOKING_SUCCESS,
  experienceBookingSuccess,
});

export const setExperienceBookingSuccess = (experienceBookingSuccess) => {
  return (dispatch) => {
    dispatch(ExperienceBookingSuccess(experienceBookingSuccess));
  };
};

export const ExperienceBookingInProgress = (experienceBookingInProgress) => ({
  type: actionTypes.SET_EXPERIENCE_BOOKING_IN_PROGRESS,
  experienceBookingInProgress,
});

export const setExperienceBookingInProgress = (experienceBookingInProgress) => {
  return (dispatch) => {
    dispatch(ExperienceBookingInProgress(experienceBookingInProgress));
  };
};

export const ExperiencesListAction = (experiencesList) => ({
  type: actionTypes.SET_EXPERIENCES_LIST,
  experiencesList,
});

export const setExperiencesList = (list) => {
  return (dispatch) => {
    dispatch(ExperiencesListAction(list));
  };
};

export const ExperienceSelectedAction = (experienceSelected) => ({
  type: actionTypes.SET_EXPERIENCE_SELECTED,
  experienceSelected,
});

export const setExperienceSelected = (experienceSelected) => {
  return (dispatch) => {
    dispatch(ExperienceSelectedAction(experienceSelected));
  };
};

export const AppointmentDataAction = (appointmentData) => {
  return {
    type: actionTypes.SET_APPOINTMENT_DATA,
    appointmentData: { ...appointmentData, messageId: window.messageId },
  };
};

export const setAppointmentData = (appointmentData) => {
  return (dispatch) => {
    dispatch(AppointmentDataAction(appointmentData));
  };
};

export const ExperienceBookingModalAction = (experienceBookingModal) => ({
  type: actionTypes.SET_EXPERIENCE_BOOKING_MODAL,
  experienceBookingModal,
});

export const setExperienceBookingModal = (experienceBookingModal) => {
  return (dispatch) => {
    dispatch(ExperienceBookingModalAction(experienceBookingModal));
  };
};

export const OnboardingAnswers = (onboardingAnswers) => ({
  type: actionTypes.SET_ONBOARDING_ANSWERS,
  onboardingAnswers,
});

export const setOnboardingAnswers = (onboardingAnswers) => {
  return (dispatch) => {
    dispatch(OnboardingAnswers(onboardingAnswers));
  };
};

export const getNewCustomerSessionId = () => ({
  type: actionTypes.GET_NEW_CUSTOMER_SESSION_ID,
  customerSessionId: uuid.v1(),
});



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/actions/experiences.js